import { render, staticRenderFns } from "./Sekretariat.vue?vue&type=template&id=406d327a&scoped=true&"
import script from "./Sekretariat.vue?vue&type=script&lang=js&"
export * from "./Sekretariat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d327a",
  null
  
)

export default component.exports